var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.invoiceDialogVisible,
            title: _vm.title,
            "destroy-on-close": "",
            "close-on-click-modal": false,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.invoiceDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formValidate",
              staticClass: "formValidate mt20",
              attrs: {
                rules: _vm.rules,
                model: _vm.form,
                "label-width": "120px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单编号", prop: "invoiceNumber" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.isView,
                              placeholder: "请输入发票编号",
                            },
                            model: {
                              value: _vm.form.orderNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "orderNo", $$v)
                              },
                              expression: "form.orderNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "客户名称", prop: "customerName" } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.isView,
                              placeholder: "请输入客户名称",
                            },
                            model: {
                              value: _vm.form.titleName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "titleName", $$v)
                              },
                              expression: "form.titleName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发票金额", prop: "payPrice" } },
                        [
                          _c(
                            "el-input",
                            {
                              attrs: {
                                disabled: _vm.isView,
                                placeholder: "请输入发票金额",
                              },
                              model: {
                                value: _vm.form.payPrice,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "payPrice", $$v)
                                },
                                expression: "form.payPrice",
                              },
                            },
                            [
                              _c("template", { slot: "append" }, [
                                _vm._v("元"),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "发票类型", prop: "titleType" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled: _vm.isView,
                                placeholder: "请选择发票类型",
                              },
                              model: {
                                value: _vm.form.titleType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "titleType", $$v)
                                },
                                expression: "form.titleType",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "个人发票", value: "个人" },
                              }),
                              _c("el-option", {
                                attrs: { label: "单位发票", value: "单位" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发票状态", prop: "status" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                disabled: _vm.isView,
                                placeholder: "请选择状态",
                              },
                              model: {
                                value: _vm.form.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "status", $$v)
                                },
                                expression: "form.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "待开票", value: "0" },
                              }),
                              _c("el-option", {
                                attrs: { label: "已开票", value: "1" },
                              }),
                              _c("el-option", {
                                attrs: { label: "已拒绝", value: "2" },
                              }),
                              _c("el-option", {
                                attrs: { label: "已作废", value: "3" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.form.titleType === "单位"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "单位税号",
                                prop: "invoiceNumber",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.form.taxNumber,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "taxNumber", $$v)
                                  },
                                  expression: "form.taxNumber",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "缩略图", prop: "fileUrl" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "upLoadPicBox acea-row",
                      on: {
                        click: function ($event) {
                          return _vm.modalPicTap("1")
                        },
                      },
                    },
                    [
                      _vm.form.fileUrl
                        ? _c("div", { staticClass: "pictrue" }, [
                            _c("img", { attrs: { src: _vm.form.fileUrl } }),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                    ]
                  ),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v("建议尺寸：800*800px，上传小于500kb的图片"),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isView,
                  expression: "!isView",
                },
              ],
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.invoiceDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }